import type { SVGProps } from "react";

export function IconDarkPurpleShieldCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.6875 14.8594L15.8125 18.9844L22.6875 12.1094M4.125 4.54688H16.5H28.875V13.8281V15.0188C28.875 20.0124 26.1677 24.6134 21.8026 27.0385L16.5 29.9844L11.1974 27.0385C6.83226 24.6134 4.125 20.0124 4.125 15.0188L4.125 13.8281L4.125 4.54688Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
    </svg>
  );
}
